import gql from 'graphql-tag'

const organisationSettingsUpdateQuery = gql`
  query organisationSettingsUpdate($id: String!, $expeditionCancelInFulfillment: Boolean) {
    organisationSettingsUpdate(id: $id, input: { expeditionCancelInFulfillment: $expeditionCancelInFulfillment })
      @rest(type: "Organisation", method: "PATCH", path: "organisation/{args.id}/settings") {
      id
      expeditionCancelInFulfillment
    }
  }
`

export default organisationSettingsUpdateQuery
